"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoreItemMappingFacade = void 0;
const tslib_1 = require("tslib");
const deepmerge_1 = tslib_1.__importDefault(require("deepmerge"));
const axios_1 = require("@goparrot/axios");
const common_1 = require("@goparrot/common");
const generated_dto_1 = require("../generated-dto");
class StoreItemMappingFacade extends axios_1.AbstractFacade {
    constructor(config = {}, interceptors) {
        super(deepmerge_1.default.all([
            {
                axiosConfig: {
                    baseURL: process.env.GOPARROT_PLATFORM_SERVICE_MENU_ORCHESTRATOR,
                },
            },
            config,
        ]), interceptors);
    }
    async list(storeId) {
        return (0, common_1.plainToInstanceWithLVS)(generated_dto_1.ReadStoreItemMappingDto, (await this.client.get(`api/v1/stores/${encodeURIComponent(storeId)}/store-item-mappings`)).data, {
            groups: [common_1.DefaultExposeGroupEnum.READ],
        });
    }
    async get(storeId, replicaUniqueName) {
        return (0, common_1.plainToInstanceWithLVS)(generated_dto_1.ReadStoreItemMappingDto, (await this.client.get(`api/v1/stores/${encodeURIComponent(storeId)}/store-item-mappings/${encodeURIComponent(replicaUniqueName)}`)).data, {
            groups: [common_1.DefaultExposeGroupEnum.READ],
        });
    }
}
exports.StoreItemMappingFacade = StoreItemMappingFacade;
//# sourceMappingURL=StoreItemMappingFacade.js.map